import { cn } from '@/lib/cn';

/**
 * Logotipo de la aplicación.
 *
 * Está partido en dos piezas a propósito:
 *
 *  · El **isotipo** (el brote sobre el cuadrado verde) se carga como imagen
 *    desde `public/logo-mark.svg`. Lleva sus colores de marca dentro y no
 *    depende del tema, así que un `<img>` basta y no hace falta duplicar
 *    ningún valor de color en el código.
 *  · El **logotipo** («CRM POSTVENTA») va en línea, dibujado con
 *    `currentColor`. Cargado como `<img>` el navegador aísla el SVG y
 *    `currentColor` resuelve al negro por defecto del documento, no al color
 *    de la página: en tema oscuro el texto quedaba negro sobre negro. Al
 *    insertarlo en el DOM hereda de `text-fg` y cambia con el tema.
 *
 * De ese modo aquí no se escribe ni un solo color: el único que hay es el
 * `currentColor` que sale del token `text-fg`.
 */
function Wordmark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 132 88" aria-hidden="true" className={cn('h-full w-auto text-fg', className)}>
      <g
        transform="translate(0 12) scale(0.52)"
        fill="none"
        stroke="currentColor"
        strokeWidth="16"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M56.97 33.03 A24 24 0 1 0 56.97 66.97" />
        <path d="M88 82 L88 18 L112 18 A15 15 0 0 1 112 48 L88 48" />
        <path d="M107 48 L125 82" />
        <path d="M156 82 L156 18 L182 54 L208 18 L208 82" />
      </g>
      <text
        x="4"
        y="72"
        fontFamily="Inter, 'Inter var', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif"
        fontSize="11"
        fontWeight="600"
        letterSpacing="3.1"
        fill="currentColor"
        opacity="0.6"
      >
        POSTVENTA
      </text>
    </svg>
  );
}

export function Logo({ className }: { className?: string }) {
  return (
    <span
      role="img"
      aria-label="CRM Postventa"
      className={cn('inline-flex h-8 shrink-0 items-center gap-2', className)}
    >
      <img src="/logo-mark.svg" alt="" aria-hidden="true" className="h-full w-auto" />
      <Wordmark />
    </span>
  );
}

/** Isotipo suelto, para la barra lateral contraída y las pantallas estrechas. */
export function LogoMark({ className }: { className?: string }) {
  return <img src="/logo-mark.svg" alt="CRM Postventa" className={cn('size-7 shrink-0', className)} />;
}
